import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import mapValues from 'lodash/mapValues';
import axios from 'axios';
import queryparse from 'tricks/string/queryparse';
import { generateCorrelationId, correlationIdHeaderName } from 'utils/telemetry';
function stringify(obj) {
  if (_typeof(obj) === 'object') {
    try {
      return JSON.stringify(obj);
    } catch (_unused) {
      return obj;
    }
  } else {
    return obj;
  }
}

/*
 * API Call
 */

export default function api(_x, _x2, _x3, _x4, _x5) {
  return _api.apply(this, arguments);
}
function _api() {
  _api = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(method, url, query, data, responseType) {
    var headers, resp, _err$response, _data, status, _data$message, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (typeof query === 'string') {
            query = queryparse(query, decodeURIComponent);
          }
          query = mapValues(query, stringify);
          headers = _defineProperty({}, correlationIdHeaderName, generateCorrelationId());
          _context.prev = 1;
          _context.next = 2;
          return axios({
            method: method,
            url: url,
            params: query,
            data: data,
            headers: headers,
            responseType: responseType
          });
        case 2:
          resp = _context.sent;
          return _context.abrupt("return", resp.data);
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          _err$response = _t.response, _data = _err$response.data, status = _err$response.status; // Restructure legacy message objects
          // @todo: refactor legacy error objects in the api
          if (_typeof(_data) === 'object') {
            (_data$message = _data.message) !== null && _data$message !== void 0 ? _data$message : _data.message = _data.error;
          }

          // The ALB returns a 502 status code when the backend is down but data is a string so get the status text and use it as the error and message
          if (!(typeof _data === 'string')) {
            _context.next = 4;
            break;
          }
          throw {
            message: _data,
            error: _data,
            status: status
          };
        case 4:
          throw _objectSpread(_objectSpread({}, _data), {}, {
            status: status
          });
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return _api.apply(this, arguments);
}